<template>
  <login v-if="isLogin" />
  <template v-else-if="isRegister">
    <register v-if="registrationStage > 0 && inviteData.invite != null && inviteData.roles != null" />
    <empty-state
      v-else
      :code="3"
      message="Access to this resource is restricted. Please check with the site admin if you believe this is a mistake."
    />
  </template>
  <custom-message
    v-if="getErrorAuthentication != null"
    :text="getErrorAuthentication"
    @close="cancelErrorAuthentication"
  />
</template>

<script setup>
import { storeToRefs } from 'pinia'

import { useAuthentication } from '@/stores/auth'

const authenticationStore = useAuthentication()

const { isLogin, isRegister, registrationStage, getErrorAuthentication, inviteData } = storeToRefs(authenticationStore)
const { cancelErrorAuthentication } = authenticationStore
</script>

<style scoped>
.video-bg {
  object-fit: cover;
}

.ai-text {
  font-size: 3.2rem;
  font-weight: bold;
  line-height: 1.2;
}
</style>
